/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Title_AccentInputs */

const en_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fame`)
};

const es_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fama`)
};

const de_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhmeshalle`)
};

const zh_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`堂`)
};

const ar_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشاهير`)
};

const fr_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renommée`)
};

const vi_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`danh vọng`)
};

const sw_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umaarufu`)
};

const th_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกียรติยศ`)
};

const bs_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slavnih`)
};

const ja_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェイム`)
};

const ko_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전당`)
};

const pt_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fama`)
};

const it_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fame`)
};

const sv_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fame`)
};

const nl_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalerij`)
};

const da_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fame`)
};

const nb_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fame`)
};

const fi_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kunniagalleria`)
};

const pl_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sław`)
};

const ru_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`славы`)
};

const tr_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müzesi`)
};

const hi_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फेम`)
};

const id_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehormatan`)
};

const ms_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemasyhuran`)
};

const cs_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slávy`)
};

const el_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διασήμων`)
};

const he_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התהילה`)
};

const af_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalery`)
};

const hu_hof_title_accent = /** @type {(inputs: Hof_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csarnoka`)
};

/**
* | output |
* | --- |
* | "Fame" |
*
* @param {Hof_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_title_accent = /** @type {((inputs?: Hof_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_title_accent(inputs)
	if (locale === "de") return de_hof_title_accent(inputs)
	if (locale === "zh") return zh_hof_title_accent(inputs)
	if (locale === "ar") return ar_hof_title_accent(inputs)
	if (locale === "fr") return fr_hof_title_accent(inputs)
	if (locale === "vi") return vi_hof_title_accent(inputs)
	if (locale === "sw") return sw_hof_title_accent(inputs)
	if (locale === "th") return th_hof_title_accent(inputs)
	if (locale === "bs") return bs_hof_title_accent(inputs)
	if (locale === "ja") return ja_hof_title_accent(inputs)
	if (locale === "ko") return ko_hof_title_accent(inputs)
	if (locale === "pt") return pt_hof_title_accent(inputs)
	if (locale === "it") return it_hof_title_accent(inputs)
	if (locale === "sv") return sv_hof_title_accent(inputs)
	if (locale === "nl") return nl_hof_title_accent(inputs)
	if (locale === "da") return da_hof_title_accent(inputs)
	if (locale === "nb") return nb_hof_title_accent(inputs)
	if (locale === "fi") return fi_hof_title_accent(inputs)
	if (locale === "pl") return pl_hof_title_accent(inputs)
	if (locale === "ru") return ru_hof_title_accent(inputs)
	if (locale === "tr") return tr_hof_title_accent(inputs)
	if (locale === "hi") return hi_hof_title_accent(inputs)
	if (locale === "id") return id_hof_title_accent(inputs)
	if (locale === "ms") return ms_hof_title_accent(inputs)
	if (locale === "cs") return cs_hof_title_accent(inputs)
	if (locale === "el") return el_hof_title_accent(inputs)
	if (locale === "he") return he_hof_title_accent(inputs)
	if (locale === "af") return af_hof_title_accent(inputs)
	if (locale === "hu") return hu_hof_title_accent(inputs)
	return en_hof_title_accent(inputs)
});